// extracted by mini-css-extract-plugin
export var danger = "_1t-6";
export var lightPink = "_1t-a";
export var medium = "_1t-j";
export var nearSquare = "_1t-m";
export var neutralBlue = "_1t-8";
export var neutralYellow = "_1t-7";
export var noCapitalize = "_1t-1";
export var normal = "_1t-2";
export var pill = "_1t-0";
export var primary = "_1t-3";
export var primaryLight = "_1t-4";
export var shadow = "_1t-n";
export var small = "_1t-k";
export var solidBlack = "_1t-i";
export var solidGreen = "_1t-d";
export var solidLightBlue = "_1t-f";
export var solidNavy = "_1t-e";
export var solidOrange = "_1t-h";
export var solidPink = "_1t-g";
export var solidRed = "_1t-b";
export var solidWhite = "_1t-9";
export var solidYellow = "_1t-c";
export var success = "_1t-5";
export var xsmall = "_1t-l";